
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teams/[slug]",
      function () {
        return require("private-next-pages/teams/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teams/[slug]"])
      });
    }
  